import { Tabs, Container, Title, Text } from '@mantine/core';
import Steps from './Steps';
import ChatGPTSteps from './ChatGPTSteps';
import {
  DONATION_MODE,
  DONATION_MODES,
  isChatgptEnabled,
  isTakeoutEnabled,
} from './config';

const tabOrder = [
  { value: 'takeout', label: 'Google Takeout', enabled: isTakeoutEnabled },
  { value: 'chatgpt', label: 'ChatGPT', enabled: isChatgptEnabled },
];

export default function DonationPage() {
  if (DONATION_MODE === DONATION_MODES.CHATGPT_ONLY) {
    return <ChatGPTSteps />;
  }

  if (DONATION_MODE === DONATION_MODES.TAKEOUT_ONLY) {
    return <Steps />;
  }

  const availableTabs = tabOrder.filter((entry) => entry.enabled());
  const defaultTab = availableTabs[0]?.value ?? 'takeout';

  return (
    <Container size="xl" py="xl">
      <Title order={2} align="center" mb="lg">
        Choose a Donation Flow
      </Title>
      {availableTabs.length > 1 ? (
        <Tabs defaultValue={defaultTab} keepMounted={false}>
          <Tabs.List>
            {availableTabs.map((tab) => (
              <Tabs.Tab key={tab.value} value={tab.value}>
                {tab.label}
              </Tabs.Tab>
            ))}
          </Tabs.List>

          <Tabs.Panel value="takeout" mt="xl">
            <Steps />
          </Tabs.Panel>

          <Tabs.Panel value="chatgpt" mt="xl">
            <ChatGPTSteps />
          </Tabs.Panel>
        </Tabs>
      ) : (
        <Text align="center" color="red">
          No donation flows are enabled. Please check the configuration.
        </Text>
      )}
    </Container>
  );
}
